// @flow
import * as React from 'react';
import Box from "@mui/material/Box";
import {Popover} from "@mui/material";

type Props = {

};

const InfoPopOver = ({infoPopOver, handleInfoPopOver, component}: Props) => {
    const handlePopOverClose = () => {
        handleInfoPopOver({anchorEl: null, open: false, body: ''})
    }

    return (
        <React.Fragment>
            <Box onClick={(e) => e.stopPropagation()}>
                <Popover
                    disableRestoreFocus
                    onClose={handlePopOverClose}
                    open={infoPopOver.open}
                    anchorEl={infoPopOver.anchorEl}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                >
                    <Box sx={{width: '100%', padding: '20px'}}>
                        {component}
                    </Box>
                </Popover>
            </Box>
        </React.Fragment>
    );
};

export default InfoPopOver